import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status align-middle" }
const _hoisted_2 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_3 = ["data-dp-tooltip"]
const _hoisted_4 = { class: "align-middle" }
const _hoisted_5 = { class: "text-muted align-middle" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "align-middle" }
const _hoisted_8 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('updateStatus', _ctx.category.category.code, _ctx.category.status_code === _ctx.StatusEnum.PUBLISHED ? _ctx.StatusEnum.NOT_PUBLISHED : _ctx.StatusEnum.PUBLISHED)), ["prevent"])),
          class: _normalizeClass(["mas mas-fill-1", [_ctx.category.status_code === _ctx.StatusEnum.PUBLISHED ? 'text-success' : 'text-danger', 'cu-p']]),
          "data-dp-tooltip": _ctx.category.status_code === _ctx.StatusEnum.PUBLISHED ? _ctx.$t('published') : _ctx.$t('notPublished')
        }, " circle ", 10, _hoisted_3)
      ])
    ]),
    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.category.category.description), 1),
    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.category.modified_name ? `(${_ctx.category.modified_name})` : ''), 1),
    _createElementVNode("td", {
      class: "align-middle",
      innerHTML: _ctx.image
    }, null, 8, _hoisted_6),
    _createElementVNode("td", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_base_offcanvas_button_open, {
          "offcanvas-id": "offcanvas-dp-main-category",
          class: "btn btn-icon btn-primary",
          onBeforeOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('editCategory', _ctx.category)))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ])
  ]))
}